<template>
  <div>
    <a-row :gutter="0">
      <a-col :span="7">
        <div class="Inspection-workbench-left">
          <work-order-issued></work-order-issued>
          <repair-order-statistics></repair-order-statistics>
          <event-notice></event-notice>
        </div>
      </a-col>
      <a-col :span="17">
        <div class="Inspection-workbench-right">
          <overview></overview>
          <div style="width: 100%; height: auto">
            <PollingMap></PollingMap>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import WorkOrderIssued from './work-order-issued.vue'
import RepairOrderStatistics from './repair-order-statistics.vue'
import EventNotice from './event-notice.vue'
import overview from './overview.vue'
import PollingMap from './PollingMap.vue'
export default {
  name: 'MainIndex',
  components: {
    WorkOrderIssued,
    RepairOrderStatistics,
    EventNotice,
    overview,
    PollingMap,
  },
  created() {
    this.setSystemName()
  },
  methods: {
    setSystemName() {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}巡检维修系统`)
    },
  },
}
</script>

<style scoped>
.Inspection-workbench-left {
  min-height: 824px;
}
.Inspection-workbench-left div {
  width: 100%;
  height: 257px;
  background: #ffffff;
  border-radius: 4px;
}
.Inspection-workbench-right {
  width: 100%;
  min-height: 824px;
  padding-left: 2%;
}
</style>
